import { ContentExpander } from '../models/content-expander.interfaces';

export const ContentExpanderMocks: ContentExpander = {
  actionBar: {
    caret: {
      position: 'right',
      type: 'tertiary',
      ariaLabel: 'View More',
      show: true
    },
    label: {
      show: true,
      text: 'View More',
      position: 'left'
    }
  },
  counts: {
    default: 3,
    increment: 5,
    total: 13
  },
  collapse: {
    block: false,
    full: true
  }
};

export const ContentExpanderWithNoLabelMocks: ContentExpander = {
  actionBar: {
    caret: {
      position: 'right',
      type: 'tertiary',
      ariaLabel: 'View More',
      show: true
    },
    label: {
      show: false,
      text: 'View More',
      position: 'left'
    }
  },
  counts: {
    default: 3,
    increment: 5,
    total: 13
  },
  collapse: {
    block: false,
    full: true
  }
};

export const ContentExpanderWithCenterLabelMocks: ContentExpander = {
  actionBar: {
    caret: {
      position: 'right',
      type: 'tertiary',
      ariaLabel: 'View More',
      show: false
    },
    label: {
      show: true,
      text: 'Load More',
      position: 'center'
    }
  },
  counts: {
    default: 3,
    increment: 10,
    total: 4
  },
  collapse: {
    block: false,
    full: true
  }
};
